require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("@tinacms/react-core"), require("react-final-form"), require("styled-components")) : "function" == typeof define && define.amd ? define(["exports", "react", "@tinacms/react-core", "react-final-form", "styled-components"], t) : t((e = e || self)["@tinacms/form-builder"] = {}, e.React, e.reactCore, e.reactFinalForm, e.styled);
}(this, function (e, u, n, c, t) {
  "use strict";

  t = t && t.hasOwnProperty("default") ? t["default"] : t;

  var _m = function m() {
    return (_m = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  function a(e) {
    var t = e.form,
        n = e.children,
        r = u.useState(0),
        o = r[0],
        i = r[1];
    return u.useEffect(function () {
      i(function (e) {
        return e + 1;
      });
    }, [t]), u.createElement(l, {
      form: t.finalForm,
      key: o + ": " + t.id
    }, n);
  }

  var l = c.Form;
  var r,
      o,
      i,
      d = t.div(i || (r = ["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 1.25rem 1.25rem 0 1.25rem;\n  white-space: nowrap;\n  overflow-x: hidden;\n  overflow-y: auto !important;\n"], o = ["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 1.25rem 1.25rem 0 1.25rem;\n  white-space: nowrap;\n  overflow-x: hidden;\n  overflow-y: auto !important;\n"], Object.defineProperty ? Object.defineProperty(r, "raw", {
    value: o
  }) : r.raw = o, i = r));

  function p(e, t, n) {
    var r = t[e];
    return !r && n && n[e] && (r = n[e]), r;
  }

  var f = u.createContext(!1);
  e.FieldsBuilder = function (e) {
    var l = e.form,
        t = e.fields,
        f = n.useCMS();
    return u.createElement(d, null, t.map(function (r) {
      if (null === r.component) return null;
      var e,
          t = f.plugins.findOrCreateMap("field").find(r.component);
      t && t.type && (e = t.type);
      var n = p("parse", r, t),
          o = p("validate", r, t),
          i = r.format;
      !i && t && t.format && (i = t.format);
      var a = r.defaultValue;
      return !n && t && t.defaultValue && (a = t.defaultValue), u.createElement(c.Field, {
        name: r.name,
        key: r.name,
        type: e,
        parse: n ? function (e, t) {
          return n(e, t, r);
        } : void 0,
        format: i ? function (e, t) {
          return i(e, t, r);
        } : void 0,
        defaultValue: a,
        validate: function validate(e, t, n) {
          if (o) return o(e, t, n, r);
        }
      }, function (e) {
        return "string" != typeof r.component && null !== r.component ? u.createElement(r.component, _m({}, e, {
          form: l.finalForm,
          tinaForm: l,
          field: r
        })) : t ? u.createElement(t.Component, _m({}, e, {
          form: l.finalForm,
          tinaForm: l,
          field: r
        })) : u.createElement("p", null, "Unrecognized field type");
      });
    }));
  }, e.FormBuilder = a, e.TinaField = function (e) {
    var r = e.Component,
        t = e.children,
        n = function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    }(e, ["Component", "children"]);

    return u.useContext(f) ? u.createElement(c.Field, _m({}, n), function (e) {
      var t = e.input,
          n = e.meta;
      return u.createElement(r, {
        input: t,
        meta: n
      });
    }) : t || null;
  }, e.TinaForm = function (e) {
    var t = e.form,
        n = e.children,
        r = u.useState(!1),
        o = r[0],
        i = r[1];
    return t ? u.createElement(f.Provider, {
      value: o
    }, u.createElement(a, {
      form: t
    }, function () {
      return n({
        isEditing: o,
        setIsEditing: i
      });
    })) : u.createElement(f.Provider, {
      value: o
    }, n({
      isEditing: o,
      setIsEditing: i
    }));
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});